{
  "combobox": {
    "default_select_placeholder": "Please select...",
    "default_search_placeholder": "Search...",
    "default_empty_message": "No results found"
  },
  "select": {
    "default_select_placeholder": "Please select...",
    "default_empty_message": "No results found"
  },
  "actions": {
    "add": "Add",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "save": "Save",
    "submit": "Submit",
    "remove": "Remove",
    "addItem": "Add {{item}}",
    "back": "Back",
    "home": "Home",
    "clear": "Clear",
    "clear_all": "Clear All",
    "select_all": "Select All",
    "done": "Done",
    "retry": "Retry",
    "publish": "Publish"
  },
  "loading": "Loading...",
  "user": {
    "user_type": {
      "school_admin": "School Admin",
      "student": "Student",
      "teacher": "Teacher"
    },
    "gender": {
      "male": "Male",
      "female": "Female",
      "other": "Other"
    }
  },
  "confirmation_dialog": {
    "title": "Are you sure?",
    "description": "This action cannot be undone."
  },
  "dirty_draft": {
    "title": "Discard unsaved changes?",
    "description": "Your changes have not been saved. Leaving this page will discard them.",
    "keep_editing": "Keep editing",
    "discard": "Discard changes"
  },
  "models": {
    "state": "State",
    "subject": "Subject",
    "speciality": "Speciality",
    "session": "Session"
  },
  "flash": {
    "alert": "Error",
    "success": "Success"
  },
  "errors": {
    "required": "Required",
    "at_least_one_option_must_be_selected": "At least one option must be selected",
    "must_be_greater_than_or_equal_to": "Must be greater than or equal to {{value}}",
    "unexpected": "An unexpected error occurred.",
    "not_found": "The page you requested could not be found.",
    "unprocessable": "The request could not be processed.",
    "server_error": "Something went wrong on our end.",
    "must_be_valid_year": "Must be a valid year",
    "must_be_valid_url": "Must be a valid URL",
    "must_be_valid_email": "Must be a valid email address",
    "must_be_valid_phone": "Must be a valid phone number"
  },
  "search": {
    "previous": "Previous",
    "next": "Next"
  },
  "boolean": {
    "true": "Yes",
    "false": "No"
  },
  "listing_profiles": {
    "listing_type": {
      "personal": "Personal Listing",
      "team": "Team Listing"
    }
  },
  "anchor": {
    "section-error": "Error in {{sectionName}} section.",
    "error-header": {
      "errors": "There are errors in the following section(s): {{sections}}",
      "errors_with_others": "There are errors in the following sections: {{sections}} and $t(form.error-header.sections, {\"count\": {{otherCount}} }).",
      "sections_one": "{{count}} other section",
      "sections_other": "{{count}} other sections"
    }
  }
}
